import React from 'react'
import "./style.scss";
import { ConversionCampaignOffer, OfferMeta } from '../../../../types/conversions';
import { formatAmount } from '../../../../utils/helpers';
import OffersIcon from '../../../../assets/icons/OffersIcon';
import RewardWalletIcon from '../../../../assets/icons/RewardWalletIcon';

const LockedOffer: React.FC<{ offer: ConversionCampaignOffer, meta: OfferMeta }> = ({ offer, meta }) => {

    const targetType = offer.visibility_target_type;

    const targetAmount = Number(offer.visibility_target_amount);
    const acheivedAmount = targetType === 'sale' ? Number(offer.optin.total_sale_amount) : Number(offer.optin.total_commission_amount);

    const percent = (acheivedAmount / targetAmount) * 100;

    return (
        <div>
            <div className="app-card">
                {
                    Boolean(offer.overlay_text) &&
                    <span className='fs-14 text-dark fw-400'>
                        {offer.overlay_text}
                    </span>
                }
                <div className="my-progress__offer-progress mt-20">
                    <div className="my-progress__offer-bar">
                        <div
                            className={`my-progress__offer-bar-fill is-${meta.color_class}`}
                            style={{ width: `${percent}%` }}
                        />
                    </div>

                    <div className="my-progress__offer-row">
                        <div className="my-progress__offer-amounts">
                            <span className={`my-progress__offer-current is-${meta.color_class}`}>{formatAmount(acheivedAmount)}</span>
                            <span className="my-progress__offer-of">OF {formatAmount(targetAmount)}</span>
                        </div>
                        <div className={`my-progress__offer-percent is-${meta.color_class}`}>{Math.round(percent)}%</div>
                    </div>
                </div>
            </div>
            <div className="app-card mt-4">
                <span className='text-dark fw-500 fs-14'>Things you'll Unlock</span>
                <div className="mt-3 d-flex flex-column gap-3">
                    <span className='text-dark-gray fs-14 fw-400 d-flex align-items-center gap-2'>
                        <OffersIcon color={`var(--${meta.color_class})`} />
                        New offers
                    </span>
                    <span className='text-dark-gray fs-14 fw-400 d-flex align-items-center gap-2'>
                        <RewardWalletIcon color={`var(--${meta.color_class})`} />
                        New type of bonus rewards
                    </span>
                </div>
            </div>
        </div>
    )
}

export default LockedOffer